// These schemes take precedence over ambiguous single-label hosts (e.g. sms:1234).
// Keep unsafe schemes intact so the editor's URI validation can reject them.
const explicitScheme =
  /^(?:https?|ftps?|mailto|tel|callto|sms|cid|xmpp|javascript|vbscript|data|file|blob):/i;
const hostAndPort = /^(?:[a-z\d](?:[a-z\d.-]*[a-z\d])?|\[[a-f\d:]+\]):\d+(?=[/?#]|$)/i;

export const normalizeLinkUrl = (input: string): string => {
  const value = input.trim();
  if (explicitScheme.test(value) || /^[#/]/.test(value)) return value;

  // A numeric port is not a URI scheme, even when the host is a single label.
  if (hostAndPort.test(value)) {
    try {
      const { hostname } = new URL(`https://${value}`);
      const loopback =
        hostname === 'localhost' || hostname === '[::1]' || /^127\.\d+\.\d+\.\d+$/.test(hostname);
      return `${loopback ? 'http' : 'https'}://${value}`;
    } catch {
      return value;
    }
  }

  return /^[a-z][a-z\d+.-]*:/i.test(value) ? value : `https://${value}`;
};
